<template>
  <div style="width: 92%; margin: 0 auto; padding-top: 35px">
    <Header :hideBack="true" title="设备出入库" />
    <div style="margin-top: 20px; line-height: 100px">
      <el-button
        :disabled="regState == 0"
        icon="el-icon-camera-solid"
        @click="scanCode"
      ></el-button>
    </div>
    <div class="item">
      <label class="lft">设备编号：</label>
      <label class="cnt">{{ data.no }}</label>
    </div>
    <div class="item">
      <label class="lft">设备名称：</label>
      <label class="cnt">{{ data.name }}</label>
    </div>
    <div class="item">
      <label class="lft">设备分类：</label>
      <label class="cnt">{{ data.type }}</label>
    </div>
    <div class="item">
      <label class="lft">在库状态：</label>
      <label class="cnt">{{ data.stock_state == 1 ? "在库" : "出库" }}</label>
    </div>
    <div
      style="margin-top: 50px; display: flex; justify-content: space-around"
      v-if="(lguser.roles && lguser.roles.indexOf(6) >= 0) || lguser.role == 6"
    >
      <el-button
        type="danger"
        :disabled="!(data.id > 0)"
        style="width: 40%"
        @click="outInStock(0)"
        >入库</el-button
      >
      <el-button
        type="primary"
        :disabled="!(data.id > 0)"
        style="width: 40%"
        @click="outInStock(1)"
        >出库</el-button
      >
    </div>
  </div>
</template>
<script>
import Header from "@/components/header.vue";
export default {
  name: "task_add",
  components: { Header },
  data() {
    return {
      regState: 0, // wx注册状态
      lguser: { name: "", role: -1 },
      data: {},
    };
  },
  mounted() {
    this.regWxInfo();
    var no = this.$route.query.no;
    if (no && no.length > 0) {
      this.showInfo(no);
    }
    this.lguser = JSON.parse(localStorage.getItem("uinfo"));
  },
  methods: {
    async regWxInfo() {
      var data = await this.$api.request.get("/device/getwxinfo", {
        params: {
          url: location.href,
        },
      });
      wx.config({
        beta: true,
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["checkJsApi", "scanQRCode"],
      });
      var that = this;
      wx.ready(function () {
        that.regState = 1;
      });
      wx.error(function (res) {
        alert("参数注册失败");
      });
    },
    scanCode() {
      var that = this;
      wx.scanQRCode({
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
        success: function (res) {
          // 回调
          var result = res.resultStr; //当needResult为1时返回处理结果
          that.showInfo(result);
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
    async showInfo(no) {
      this.data = await this.$api.request.get("/device/get", {
        params: {
          no: no,
        },
      });
    },
    async outInStock(type) {
      await this.$api.request.post("/device/outin_stock", {
        no: this.data.no,
        type: type,
      });
      this.$api.success("操作成功");
      this.showInfo(this.data.no);
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.item .lft {
  text-align: left;
  min-width: 80px;
}
.item .cnt {
  text-align: right;
  width: 100%;
}
.btitle {
  font-size: 17px;
  background: #eee;
  text-align: left;
  line-height: 35px;
  padding-left: 5px;
  margin-top: 20px;
}
.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  border-left: 1px solid #fff;
  border-top: 1px solid #fff;
}
.tb th,
.tb td {
  font-weight: normal;
  background: #e0f4ff;
  font-size: 13px;
  line-height: 30px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.tb td {
  line-height: 25px;
}
</style>
